"use client";

import { c as _c } from "react/compiler-runtime";
import { BottomSheet, BottomSheetBody, BottomSheetHeader, BottomSheetHeaderTitle, FlexColumn, Input, Media, TextLabel } from "@opensea/ui-kit";
import { useRef, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { MINIMUM_LISTING_PRICE } from "../../../constants";
export const SetPriceInput = t0 => {
  const $ = _c(36);
  const {
    listingSymbol
  } = t0;
  const t = useTranslations("wallet.SetPriceInput");
  const {
    control,
    setValue
  } = useFormContext();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "listings"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const listings = useWatch(t1);
  if (listings.length === 1) {
    return null;
  }
  let t2;
  if ($[2] !== listings || $[3] !== setValue) {
    t2 = e => {
      const price = Number(e.target.value);
      if (!Number.isNaN(price)) {
        listings.forEach((_, index) => {
          setValue(`listings.${index}.price`, price, {
            shouldValidate: true
          });
        });
      }
    };
    $[2] = listings;
    $[3] = setValue;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== listingSymbol || $[6] !== t2) {
    t3 = <Input className="font-mono md:w-[120px]" endEnhancer={listingSymbol} inputRef={ref} onChange={t2} placeholder="0.0" size="sm" step={MINIMUM_LISTING_PRICE} type="number" />;
    $[5] = listingSymbol;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const input = t3;
  let t4;
  if ($[8] !== t) {
    t4 = t("custom");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <BottomSheetHeader><BottomSheetHeaderTitle>{t4}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("setAllPricesTo");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <TextLabel color="text-secondary" size="2xs">{t6}</TextLabel>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== input || $[17] !== t7) {
    t8 = <BottomSheetBody><FlexColumn className="gap-3">{t7}{input}</FlexColumn></BottomSheetBody>;
    $[16] = input;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsOpen(true);
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("custom");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <Button onClick={t10} size="sm" variant="secondary">{t11}</Button>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== isOpen || $[28] !== t12 || $[29] !== t9) {
    t13 = <Media lessThan="md"><BottomSheet content={t9} nested={true} onOpenChange={setIsOpen} open={isOpen}>{t12}</BottomSheet></Media>;
    $[27] = isOpen;
    $[28] = t12;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== input) {
    t14 = <Media greaterThanOrEqual="md">{input}</Media>;
    $[31] = input;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};